var _image;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    id: "image0",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYBAMAAAASWSDLAAAABGdBTUEAALGPC/xhBQAAACBjSFJN AAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAG1BMVEUAAAAzNkEzN0AzN0A0 OD8zN0AyOUAzN0AAAAD3RO7qAAAAB3RSTlMAS+TjSeJIQmFxvQAAAAFiS0dEAIgFHUgAAAAJcEhZ cwAAAEgAAABIAEbJaz4AAAAHdElNRQfmBhQUMRCcN3stAAAAOElEQVQY02NgQAFC5WAA4Zgjc8qR laFxILqKHcAcqK4AMAeikL1goDgMZHGQvMDA4AxmlyagBhQAXLgmiZUJEkAAAAAldEVYdGRhdGU6 Y3JlYXRlADIwMjItMDYtMjBUMTc6NDk6MTYrMDM6MDB6UxGKAAAAJXRFWHRkYXRlOm1vZGlmeQAy MDIyLTA2LTIwVDE3OjQ5OjE2KzAzOjAwCw6pNgAAACh0RVh0c3ZnOmJhc2UtdXJpAGZpbGU6Ly8v dG1wL21hZ2ljay10MGVMUGVyed3XwpMAAAAASUVORK5CYII="
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copy-icon.1332a8f1f9b4a5e0baf29143a8e2952e.svg";
export { ForwardRef as ReactComponent };